var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImportSide = function SvgImportSide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.7,
    y1: 174.47,
    x2: 206.33,
    y2: 20.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,139.99c2.76,0,5,2.24,5,5v30.01c0,8.28,6.72,15,15,15h109.99c8.28,0,15-6.72,15-15V50.01h-35c-2.76,0-5-2.24-5-5V10.01H45c-8.28,0-15,6.72-15,15v19.99c0,2.76-2.24,5-5,5s-5-2.24-5-5v-19.99C20,11.2,31.19.01,45,.01h89.72c1.33-.08,2.71.36,3.82,1.46l40,40c1.11,1.11,1.55,2.49,1.46,3.82v129.71c0,13.81-11.19,25-25,25H45c-13.81,0-25-11.19-25-25v-30.01c0-2.76,2.24-5,5-5ZM139.99,17.08v22.93h22.93l-22.93-22.93ZM102.92,90l-21.46-21.46c-1.95-1.95-1.95-5.12,0-7.07,1.95-1.95,5.12-1.95,7.07,0l30,30c1.95,1.95,1.95,5.12,0,7.07l-30,30c-1.95,1.95-5.12,1.95-7.07,0-1.95-1.95-1.95-5.12,0-7.07l21.46-21.46H25c-2.76,0-5-2.24-5-5s2.24-5,5-5h77.93Z"
  })));
};
export default SvgImportSide;